import React, { useEffect, useState } from 'react'

import { useAppDispatch, useAppSelector } from '../../../hooks';
import { inviteStaffMember, inviteVolunteer } from '../../../managers/redux/slices/team';

// mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import isEmail from 'validator/lib/isEmail'
import { COLORS } from '../../../theme/muiTheme';
import { StaffProfile } from '../../../API';

interface IInviteStaff {
    name: string
    visible: boolean
    onClose: (newStaffMember: StaffProfile | null) => void
}

export default function InviteStaffFromPicker(props: IInviteStaff) {

    const dispatch = useAppDispatch()

    useEffect(() => {
        setVisible(props.visible)
    }, [props.visible])

    function handleClose(newStaffMember: StaffProfile | null) {
        setVisible(false)
        props.onClose(newStaffMember)
    }

    const [visible, setVisible] = useState(false)
    const [email, setEmail] = useState<null | string>(null)
    const [name, setName] = useState<null | string>(null)

    const [typeOfStaffMember, setTypeOfStaffMember] = useState<'staff' | 'admin' | 'superVolunteer'>('staff')

    async function _handleClick() {
        const createStaffMemberResponse = await dispatch(inviteStaffMember({
            email: email,
            name: name,
            staffRole: typeOfStaffMember
        }))
        handleClose(createStaffMemberResponse.payload.staffProfile)
    }

    return (
        <div>
            <Dialog
                open={visible}
                onClose={() => handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="lg"
                fullWidth
            >
                <div className="p-4">
                    <DialogContent>
                        <Typography variant="h3">Add a new team member</Typography>
                        <Typography variant="body1">Invite a new staff member to your organization</Typography>

                        <div className="d-flex flex-row justify-content-center align-items-center">
                            <TextField
                                id="addTeamMemberName"
                                variant="standard"
                                label="Name"
                                placeholder="Name"
                                className="m-2"
                                inputProps={{ style: { fontSize: 16 } }}
                                fullWidth
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value)
                                }}
                            />
                            <TextField
                                id="addTeamMemberEmail"
                                variant="standard"
                                label="Email*"
                                placeholder="Email Address"
                                className="m-2"
                                inputProps={{ style: { fontSize: 16 } }}
                                fullWidth
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                }}
                            />
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Type of Team Member*</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={typeOfStaffMember}
                                    label="Type of Staff Member"
                                    variant="standard"
                                    onChange={(e) => {
                                        if (e.target.value == 'staff') {
                                            setTypeOfStaffMember('staff')
                                        } else if (e.target.value == 'superVolunteer') {
                                            setTypeOfStaffMember('superVolunteer')
                                        } else if (e.target.value == 'admin') {
                                            setTypeOfStaffMember('admin')
                                        }
                                    }}
                                >
                                    <MenuItem value="staff">Staff</MenuItem>
                                    <MenuItem value="superVolunteer">Super Volunteer</MenuItem>
                                    <MenuItem value="admin">Admin</MenuItem>
                                </Select>
                            </FormControl>
                            <Button
                                onClick={_handleClick}
                                variant="contained"
                                disabled={email != '' && email != null && !isEmail(email)}
                            >
                                Invite
                            </Button>
                        </div>
                    </DialogContent>
                </div>
                <DialogActions className="mt-3">
                    <Button onClick={() => handleClose(null)}>Close</Button>
                    {/* <Button
                        onClick={_handleClick}
                        variant="contained"
                        disabled={email != '' && email != null && !isEmail(email)}
                    >
                        Send Invitation
                    </Button> */}
                </DialogActions>
            </Dialog>
            <div id="map"></div>
        </div>
    )
}